import React, { useState, useEffect, useCallback } from 'react';
import { FileText, Plus, History } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import apiService from '../../services/apiService';
import VentasFacturablesTab from './components/VentasFacturablesTab';
import HistorialFacturasTab from './components/HistorialFacturasTab';
import './FacturacionPage.css';

const FacturacionPage = () => {
  const { showToast } = useApp();
  const [activeTab, setActiveTab] = useState('crear');
  // Catálogos SAT
  const [catalogos, setCatalogos] = useState({
    regimenesFiscales: [],
    usosCFDI: [],
    formasPago: [],
    metodosPago: []
  });
  const [catalogosLoaded, setCatalogosLoaded] = useState(false);

  // Cargar catálogos SAT
  const cargarCatalogos = useCallback(async () => {
    try {
      const [regimenesRes, usosRes, formasRes, metodosRes] = await Promise.all([
        apiService.getCatalogoRegimenFiscal(),
        apiService.getCatalogoUsoCFDI(),
        apiService.getCatalogoFormaPago(),
        apiService.getCatalogoMetodoPago()
      ]);

      setCatalogos({
        regimenesFiscales: regimenesRes.success ? regimenesRes.data : [],
        usosCFDI: usosRes.success ? usosRes.data : [],
        formasPago: formasRes.success ? formasRes.data : [],
        metodosPago: metodosRes.success ? metodosRes.data : []
      });
      setCatalogosLoaded(true);
    } catch (error) {
      console.error('Error cargando catálogos:', error);
      showToast('Error al cargar catálogos SAT', 'error');
    }
  }, [showToast]);

  useEffect(() => {
    cargarCatalogos();
  }, [cargarCatalogos]);

  const tabs = [
    { id: 'crear', label: 'Crear Factura', icon: Plus },
    { id: 'historial', label: 'Historial', icon: History }
  ];

  return (
    <div className="facturacion-page">
      {/* Header */}
      <div className="facturacion-header">
        <div className="header-title">
          <FileText size={24} />
          <h1>Facturación CFDI</h1>
        </div>
      </div>

      {/* Tabs */}
      <div className="facturacion-tabs">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`tab-btn ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <tab.icon size={18} />
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="facturacion-content">
        {activeTab === 'crear' && catalogosLoaded && (
          <VentasFacturablesTab
            catalogos={catalogos}
            onFacturaCreated={() => setActiveTab('historial')}
          />
        )}

        {activeTab === 'historial' && (
          <HistorialFacturasTab catalogos={catalogos} />
        )}
      </div>

    </div>
  );
};

export default FacturacionPage;
